import { environment } from './../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantsStore {

  public apiUrl = environment.apiUrl;


  // @ CEDLAB TABLES
  //#region CedLab Tables
  benchmarkUrl = this.apiUrl + '/VwLabBenchmarkG';
  bonusContinuaUrl = this.apiUrl + '/VwLabBonusContinua/';
  bonusDiscretaUrl = this.apiUrl + '/VwLabBonusDiscreta';
  nextValutationDateUrl = this.apiUrl + '/VwLabNextValutationDate';

  nextValutationDateUrlGuest = this.nextValutationDateUrl + '/Guest';

  scontiUrl = this.apiUrl + '/VwLabSconti';
  sotto100Url = this.apiUrl + '/VwLabSotto100';
  topCedoleMemoriaUrl = this.apiUrl + '/VwLab2023CedoleMemoria';
  topVetrinaMeseUrl = this.apiUrl + '/TblVetrinaMese/top';
  vetrinaMeseUrl = this.apiUrl + '/TblVetrinaMese';

  topFlopUrl = this.apiUrl + '/VwLabTopFlop';
  nuoveEmissioniUrl = this.apiUrl + '/VwLab2019NuoveEmissioni';
  //#endregion

  //#region //* WATCHLISTS MANAGEMENT
  watchlistUrl = this.apiUrl + '/VwLabWatchlist';
  watchlistManagementUrl = this.apiUrl + '/TblLabWatch';
  //#endregion

  //#region //* PORTFOLIOS MANAGEMENT
  portafoglioManagementUrl = this.apiUrl + '/TblLabWatchPortafoglio';
  portafoglioUrl = this.apiUrl + '/VwLabPortfolio';
  //#endregion

  infoUrl = this.apiUrl + '/TablesInfo';
  newsUrl = this.apiUrl + '/News';
  matriceUrl = this.apiUrl + '/VwMatrice';
  subMatriceSearchUrl = this.apiUrl + '/VwLabSearch4';
  calendarioEventiUrl = this.apiUrl + '/VwLabOutlook';
  calendarioEventiPrivatiUrl = this.apiUrl + '/VwLabOutlook/private';
  // isinListUrl = `${this.apiUrl}/VwLabSearch6`;
  isinListUrl = `${this.apiUrl}/TblAllCed`;

  visibleIsinListUrl = `${this.apiUrl}/TblAllCed/TblAllCedVisible`;

  autocompleteSottostanteValues = this.apiUrl + '/TblSottostante/sottostanteAutocomplete';
  filteredSottostante = this.apiUrl + '/TblSottostante';
  schedaSottostanteUrl = this.apiUrl + '/TblSottostante/schedaSottostante';
  privacyUrl = `${this.apiUrl}/Disclaimers`;

  // Scheda Certificato
  DettaglioIsinRecordsUrl =  this.apiUrl + '/VwCedLab2020IsinDettaglio/';
  VariazioneSottostanteUrl =  this.apiUrl + '/VwLabVariazioneSottostante3/';
  sottostantiRimborsati = this.apiUrl + '/VwSottostantiRimborsati/';
  AnalisiScenarioAnnuoUrl =  this.apiUrl + '/AnalisiScenarioAnnuo/';
  RilevamentoUrl =  this.apiUrl + '/TblRilevamento/';
  SchedaEmittenteUrl =  this.apiUrl + '/TblEmittenti/';
  DividendiUrl =  this.apiUrl + '/TblDividendi/';
  DocumentoInformazioniChiaveUrl = this.apiUrl + '/TblKeyInformationDocuments/';
  SchedaCertificatoUrl = this.apiUrl + '/SchedaCertificato/pdf';
  upsertPrezzoCertificato = this.DettaglioIsinRecordsUrl + 'PrezzoCertificato';

  // Other
  userProfileUrl = `${this.apiUrl}/api/Profile`;
  imageUrl = this.apiUrl + '/Images';
  notificationsUrl = this.apiUrl + '/Notifications';

  acquistaServiziUrl = `${this.apiUrl}/AcquistaServizi`;
  userBuyingsUrl = `${this.apiUrl}/UserBuyings`;
  ordersUrl = `${this.apiUrl}/CompletePurchase`;
  orderSendMailsUrl = `${this.ordersUrl}/SendMails`;
  autocompleteProductsUrl = this.apiUrl + '/AcquistaServizi/GetAutocompleteValues';

  userSettingsUrl = `${this.apiUrl}/UserSettings`;

  advancedSearchExtendedUrl = `${this.apiUrl}/TblAdvancedSearchExtended`;
  advancedSearchExtendedV2Url = `${this.apiUrl}/v2/TblAdvancedSearchExtended`;

  savedSearchUrl = `${this.apiUrl}/TblSavedSearch`;
  savedSearchV2Url = `${this.apiUrl}/v2/TblSavedSearch`;

  advancedSearchTableColumnsToShowUrl = `${this.apiUrl}/TblAdvancedSearchTableColumnsToShow`;

  diagnosticsUrl = `${this.apiUrl}/Diagnostics`;

  eventsUrl = `${this.apiUrl}/Events`;

  aboutCedlabUrl = `${this.apiUrl}/AboutCedlab`;
  disclaimerTable = 'Attenzione! Certificati e Derivati Srl mantiene la titolarità e i diritti di proprietà, anche intellettuale, dei dati mostrati. E’ espressamente proibito, copiare, noleggiare, rivendere o utilizzare per lo sviluppo di applicazioni terze (anche web) il flusso dati incluse, senza limitazioni, le tabelle contenenti le definizioni dei certificati.';
  disclaimerAccountNonCondivisibile = 'L’account è personale e non è condivisibile. Eventuali condivisioni rilevate faranno decadere l’abbonamento e comporteranno la chiusura immediata dell’account';
  cedoleIncassate = `${this.RilevamentoUrl}portfolio`;
  dateOsservazioneRecords = `${this.RilevamentoUrl}portfolio`;

  legalDocumentsUrl = `${this.apiUrl}/legal-documents`;
  userConsentsUrl = `${this.apiUrl}/user-consents`;

  constructor() {
  }

  filterAndAscendingQueryString(filter: string, ascending: boolean): string {
    const filterQueryString = (filter != null) ? ('/' + filter) : '';
    const ascendingQueryString = (filter != null && ascending != null ) ? ('/' + ascending) : '';
    return filterQueryString + ascendingQueryString;
  }
}
